import { forwardRef } from 'react';
import { typographyRecipe, TypographyRecipe } from './typography.css';
import { clsx } from 'clsx';
import { sprinkles, Sprinkles } from '../../sprinkles.css';
import { TMap } from '@client/new/helpers/types';
import { fontWeight as fontWeightToken } from '@design-system/tokens';

export type TypographyProps = React.HTMLAttributes<HTMLParagraphElement> &
  TypographyRecipe &
  Pick<Sprinkles, 'color'> & {
    as?: React.ElementType;
  };

const tagMap: TMap<TypographyRecipe['variant'], React.ElementType> = {
  display: 'h2',
  headline: 'h3',
  title: 'h4',
  body: 'p',
  bodyLarge: 'p',
};

const Typography = forwardRef<HTMLParagraphElement, TypographyProps>(
  (
    {
      className,
      variant = 'body',
      size = 'medium',
      color,
      fontWeight,
      uppercase = false,
      as: Component = tagMap[variant],
      ...props
    },
    ref,
  ) => {
    const cn = clsx([
      typographyRecipe({ variant, size, uppercase }),
      sprinkles({ color }),
      className,
    ]);

    return (
      <Component
        className={cn}
        ref={ref}
        style={fontWeight ? { fontWeight: fontWeightToken[fontWeight] } : {}}
        {...props}
      />
    );
  },
);

Typography.displayName = 'Typography';

export { Typography, typographyRecipe };
